// populates missing values
module.exports = function(dst, src) {

  Object.keys(src).forEach(function(prop)
  {
    dst[prop] = dst[prop] || src[prop];
  });

  return dst;
};



//////////////////
// WEBPACK FOOTER
// ./~/form-data/lib/populate.js
// module id = 1291
// module chunks = 0 1 3